import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { LinkTo } from '@ember/routing'
import { t } from 'ember-intl'
import { hash } from '@ember/helper'

interface Signature {
  Element: HTMLAnchorElement
  Args: {
    bookId: string
  }
}

export const BookLibraryResourcesLink: TOC<Signature> = <template>
  <LinkTo
    data-test-resources-for-book={{@bookId}}
    @query={{hash bookId=@bookId bookTab="resources"}}
    class="bg-cornflower-blue-100 text-cornflower-blue-350 cursor-pointer rounded-full px-3 py-1 font-semibold whitespace-nowrap no-underline select-none"
    ...attributes
  >
    <span class="pr-1">
      <PhosphorIcon @icon="phosphor-file-text-fill" />
    </span>
    <span class="resources-link-text">
      {{t "bookLibrary.components.resourcesLink.text"}}
    </span>
  </LinkTo>
</template>

export default BookLibraryResourcesLink
